import React from 'react'
import Navigation from './Navigation'
import Header from './Header'

const Layout = (props) => {
    const { isNavigationCollapsed, toggleNavigation } = props
    const navigationOverlayCls = (isNavigationCollapsed) ? 'navigation-overlay' : 'navigation-overlay navigation-expanded'
    return (
        <div>
            <Header {...props}/>
            <div className="wrapper">
                <Navigation {...props}/>
                <div className="content-container">
                    {props.children}
                    <div className={navigationOverlayCls} onClick={toggleNavigation} />
                </div>
            </div>
        </div>)
}

export default Layout





// WEBPACK FOOTER //
// ./src/modules/layout/component/Layout.js